/**
 * Helper to make cart requests, including error handling
 *
 * @param {String} url Request endpoint
 * @param {Object} data Request data payload
 * @param {String} method Default 'POST
 * @param {Object} options Additional request options
 * @returns {JSON} response
 */
const cartRequest = async (url, data, method = 'POST', options = {}) => {
  const response = await fetch(url, {
    method,
    mode: 'cors',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ data }),
    ...options
  });

  let jsonResponse;
  try {
    jsonResponse = await response.json();
  } catch (error) {
    // unable to parse json out of the response, so log an error
    throw new Error(`Error in json parse: ${error},\n response: ${response}`);
  }

  if (response.ok) {
    if (response.status === 204) {
      // shouldn't expect a response body for this status
      // see: https://developer.mozilla.org/en-US/docs/Web/HTTP/Status/204
      return '';
    }

    if (jsonResponse?.error) {
      throw new Error(
        `Successful response, but data indicated an error: ${jsonResponse.error}`
      );
    }

    return jsonResponse;
  } else {
    throw new Error(`Server error, HTTP status ${response.status}`);
  }
};

export default cartRequest;
